import { useEffect, useState } from 'react';

export default function Gracias() {
  const [shake, setShake] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const interval = setInterval(() => {
      setShake(true);
      setTimeout(() => setShake(false), 600);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const target = new Date('2026-03-05T12:00:00');

    const tick = () => {
      const now = new Date();
      const diff = target.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setTimeLeft({ days, hours, minutes, seconds });
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#185a7d] via-[#1a6a92] to-[#185a7d] flex items-center justify-center px-4 py-10">
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0) scale(1.02); }
          15% { transform: translateX(-6px) scale(1.02); }
          30% { transform: translateX(6px) scale(1.02); }
          45% { transform: translateX(-4px) scale(1.02); }
          60% { transform: translateX(4px) scale(1.02); }
          75% { transform: translateX(-2px) scale(1.02); }
        }
        .btn-shake {
          animation: shake 0.6s ease-in-out;
        }
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37,211,102,0.5); }
          50% { box-shadow: 0 0 0 14px rgba(37,211,102,0); }
        }
        .btn-pulse {
          animation: pulse-glow 2s infinite;
        }
        @keyframes countdown-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.04); }
        }
        .countdown-digit {
          animation: countdown-pulse 1s ease-in-out infinite;
        }
      `}</style>

      <div className="max-w-xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">

          {/* Cabecera urgente */}
          <div className="bg-gradient-to-r from-[#185a7d] to-[#1a6a92] px-6 pt-8 pb-6 text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-hand-heart-line text-3xl text-white"></i>
            </div>
            <h1 className="text-2xl lg:text-3xl font-black text-white leading-tight mb-3">
              ¡Ya casi estás dentro!
            </h1>
            {/* Badge de alerta */}
            <div className="inline-flex items-center gap-2 bg-[#d1b168] text-white text-xs font-black px-4 py-2 rounded-full uppercase tracking-wide">
              <i className="ri-error-warning-fill text-sm"></i>
              Tu registro aún NO está completo
            </div>
            <p className="text-white/70 text-xs mt-3">
              Únete al grupo para confirmar tu plaza
            </p>
          </div>

          <div className="px-6 py-6">

            {/* BOTÓN WHATSAPP — arriba del todo, grande y llamativo */}
            <a
              href="https://chat.whatsapp.com/ES24YlOEZkkLx2nhgjYoJ6"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white font-black text-base lg:text-lg w-full px-6 py-4 rounded-2xl transition-colors duration-300 whitespace-nowrap cursor-pointer btn-pulse ${shake ? 'btn-shake' : ''}`}
            >
              <i className="ri-whatsapp-line text-2xl flex-shrink-0"></i>
              <span>Unirme a la Comunidad de WhatsApp</span>
              <i className="ri-arrow-right-line text-xl flex-shrink-0"></i>
            </a>
            <p className="text-center text-xs text-gray-400 mt-2 mb-4">
              Solo queda este paso — tarda menos de 10 segundos
            </p>

            {/* CUENTA ATRÁS — justo debajo del botón */}
            <div className="bg-gradient-to-br from-[#185a7d] to-[#1a6a92] rounded-2xl px-4 py-5 text-center mb-5">
              <div className="flex items-center justify-center gap-2 mb-3">
                <i className="ri-time-line text-[#d1b168] text-xl"></i>
                <p className="text-white font-black text-sm uppercase tracking-widest">La venta abre en</p>
              </div>
              <div className="flex items-center justify-center gap-2">
                {[
                  { value: timeLeft.days, label: 'Días' },
                  { value: timeLeft.hours, label: 'Horas' },
                  { value: timeLeft.minutes, label: 'Min' },
                  { value: timeLeft.seconds, label: 'Seg' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="flex flex-col items-center">
                      <div className="bg-white/15 border border-white/20 rounded-xl w-16 h-16 flex items-center justify-center countdown-digit">
                        <span className="text-3xl font-black text-white tabular-nums">
                          {String(item.value).padStart(2, '0')}
                        </span>
                      </div>
                      <span className="text-white/70 text-xs mt-1.5 font-bold uppercase tracking-wider">{item.label}</span>
                    </div>
                    {i < 3 && (
                      <span className="text-[#d1b168] font-black text-2xl mb-5 leading-none">:</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-white/70 text-xs mt-3 font-medium">
                Jueves 5 de marzo · 12:00 h (mediodía)
              </p>
            </div>

            {/* Separador "Por qué es clave" */}
            <div className="flex items-center gap-3 mb-5">
              <div className="flex-1 h-px bg-gray-200"></div>
              <span className="text-xs font-black text-[#185a7d] uppercase tracking-widest">Por qué unirte al grupo es clave</span>
              <div className="flex-1 h-px bg-gray-200"></div>
            </div>

            {/* Bloque de urgencia */}
            <div className="bg-[#d1b168]/10 border border-[#d1b168]/30 rounded-xl px-4 py-3 mb-5 text-center">
              <p className="text-sm font-bold text-[#185a7d] leading-snug">
                La 1ª edición se llenó en <span className="text-[#d1b168]">10 días</span>. Esta vez será antes.<br />
                <span className="font-normal text-gray-600 text-xs">Los del grupo tienen acceso prioritario antes de que abra al público.</span>
              </p>
            </div>

            {/* 3 razones — grandes y potentes */}
            <div className="space-y-3">
              <div className="flex items-start gap-4 bg-[#185a7d]/5 border border-[#185a7d]/10 rounded-xl px-4 py-4">
                <div className="w-11 h-11 bg-[#d1b168] rounded-full flex items-center justify-center flex-shrink-0 shadow-md">
                  <i className="ri-vip-crown-line text-white text-base"></i>
                </div>
                <div>
                  <p className="text-sm font-black text-gray-900 mb-1">Precio de lanzamiento exclusivo</p>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    El precio especial de lanzamiento <strong className="text-[#185a7d]">desaparece el 5 de marzo</strong>, sin excepciones ni prórrogas. Solo los del grupo lo tienen garantizado.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-[#185a7d]/5 border border-[#185a7d]/10 rounded-xl px-4 py-4">
                <div className="w-11 h-11 bg-[#d1b168] rounded-full flex items-center justify-center flex-shrink-0 shadow-md">
                  <i className="ri-fire-line text-white text-base"></i>
                </div>
                <div>
                  <p className="text-sm font-black text-gray-900 mb-1">Plazas contadas — sin excepciones</p>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    La formación tiene un cupo máximo para garantizar la calidad. Cuando se llene, <strong>no habrá más plazas</strong>. El grupo es la única forma de asegurar la tuya.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-[#185a7d]/5 border border-[#185a7d]/10 rounded-xl px-4 py-4">
                <div className="w-11 h-11 bg-[#d1b168] rounded-full flex items-center justify-center flex-shrink-0 shadow-md">
                  <i className="ri-rocket-line text-white text-base"></i>
                </div>
                <div>
                  <p className="text-sm font-black text-gray-900 mb-1">Acceso anticipado + contenido exclusivo</p>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Los miembros del grupo reciben <strong>novedades, fechas y materiales</strong> antes que nadie. Es donde ocurre todo antes de que sea público.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-100 mt-6 pt-4 text-center">
              <p className="text-xs text-gray-400">
                ¿Problemas?{' '}
                <a href="mailto:info@nsca.es" className="text-[#185a7d] font-semibold hover:underline">
                  info@nsca.es
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
}
